import { action } from 'typesafe-actions';
import { VisaPrepFormActionTypes } from './types';

export const createUpdateVPIFieldAction = (fieldName: string, value: any, refValue?: any) =>
  action(VisaPrepFormActionTypes.UPDATE_VPI_FIELD, {
    fieldName,
    value,
    refValue
  });
